export const environment = {
  production: false,
  graphqlUrl: 'https://dev.kdm.api.innovax.cl/graphql', // URL base para consultar la API de GraphQL
  apiUrl: 'https://dev.kdm.api.innovax.cl/api' // URL base para la API de almacenamiento
};
